import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";
import { useNavigate } from "react-router";

import { ApiError } from "@shared/types";
import { Discount } from "@modules/discounts/types";
import { DiscountFormValues } from "@modules/discounts/validations";

import { createDiscountService } from "./service";
import { UseCreateDiscountMutationOptions } from "./types";
import { listDiscountsQueryKey } from "../../queries/listDiscounts/query";

export function useCreateDiscountMutation(
  options?: UseCreateDiscountMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<Discount, ApiError, DiscountFormValues>({
    mutationFn: createDiscountService,
    onSuccess: (discount: Discount) => {
      open?.({
        type: "success",
        message: translate("v1/discount_admin.success.create"),
      });

      queryClient.invalidateQueries({
        queryKey: listDiscountsQueryKey(),
      });

      navigate(`/discounts/edit/${discount.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
